import { gql } from '@apollo/client';

export const SET_GLOBAL_FEATURE_LIMIT = gql`
  mutation SetGlobalFeatureLimit($input: SetGlobalFeatureLimitInput!) {
    setGlobalFeatureLimit(input: $input) {
      id
      featureKey
      monthlyLimit
    }
  }
`;

export const SET_USER_FEATURE_LIMIT = gql`
  mutation SetUserFeatureLimit($input: SetUserFeatureLimitInput!) {
    setUserFeatureLimit(input: $input) {
      id
      featureKey
      userId
      monthlyLimit
    }
  }
`;

export const RESET_USER_FEATURE_LIMIT = gql`
  mutation ResetUserFeatureLimit($userId: ID!, $featureKey: FeatureLimitKey!) {
    resetUserFeatureLimit(userId: $userId, featureKey: $featureKey)
  }
`;
